module.exports = __webpack_public_path__ + "Roboto-RegularItalic.90dbf902b8d0592e1beb.ttf";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/roboto-fontface/fonts/roboto/Roboto-RegularItalic.ttf
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-RegularItalic.ttf
// module chunks = styles